import { render, staticRenderFns } from "./CrashGame.vue?vue&type=template&id=a87b91b6&scoped=true"
import script from "./CrashGame.vue?vue&type=script&lang=js"
export * from "./CrashGame.vue?vue&type=script&lang=js"
import style0 from "./CrashGame.vue?vue&type=style&index=0&id=a87b91b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87b91b6",
  null
  
)

export default component.exports